import React, { useState } from "react";
import { getId } from "~assets/frontend/_util/getId";
import { dispatchTrackingEvent } from "~assets/global/tracking/tracking-event";
export const SearchResultText = ({ image, title, link, overline, intro }) => {
    const [uuid, setUuid] = useState(getId);
    const trackSearchResult = (event) => {
        const uiEvent = {
            name: "ui",
            payload: {
                ui_component: "frm-search",
                ui_function: "navigate",
                ui_action: "result",
                ui_target: event.currentTarget,
            },
        };
        dispatchTrackingEvent(uiEvent);
    };
    return (React.createElement("a", { href: link, className: "group/result-text", "aria-labelledby": uuid, onClick: trackSearchResult },
        overline && React.createElement("p", { className: "text-black-40" }, overline),
        React.createElement("h4", { id: uuid, className: "transition-colors group-hover/result-text:text-red-100" }, title),
        intro && React.createElement("p", { className: "text-16 text-black-40" }, intro)));
};
